module.exports = __webpack_public_path__ + "static/media/2016-weihnachten-ehrendan-hermann.27f6d764.jpg";